import React from 'react';

interface Column {
  key: string;
  label: string;
}

interface StatsTableProps {
  columns: Column[];
  rows: Record<string, any>[];
  title?: string;
}

const StatsTable: React.FC<StatsTableProps> = ({ columns, rows, title }) => {
  return (
    <div className="stats-table">
      {title && <h4 className="stats-table__title">{title}</h4>}
      <table className="stats-table__table">
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="stats-table__empty">No data available</td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr key={idx}>
                {columns.map(col => (
                  <td key={col.key}>{row[col.key] ?? '—'}</td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StatsTable;
